import { Outlet } from "react-router";

const Layout = () => {
  return (
    <div className='relative dark:bg-background bg-primary-foreground text-foreground !border-0'>
      <Outlet />
    </div>
  );
};

export default Layout;
